import type { PeekPriceHotelCardData } from './accommodation';
import type { PeekPriceMultiIngredientCard } from './multiIngredient';
import type { PeekPriceMediumBookableTransportCardData } from './transport';

export const enum PeekPriceModalItineraryType {
  HotelOnly = 'hotelOnly',
  FlightPlusHotel = 'flightPlusHotel',
  UnavailableFlightPlusHotel = 'unavailableFlightPlusHotel',
  FerryPlusHotel = 'ferryPlusHotel',
  UnavailableFerryPlusHotel = 'unavailableFerryPlusHotel',
  MultiIngredient = 'multiIngredient',
}

export interface PeekPriceModalHotelOnlyItinerary {
  type: PeekPriceModalItineraryType.HotelOnly;
  dates: string | undefined;
  price: string | undefined;
  paxes: string;
  hotel: PeekPriceHotelCardData;
}

export interface PeekPriceModalFlightPlusHotelItinerary {
  type: PeekPriceModalItineraryType.FlightPlusHotel;
  tripDeparture: string | undefined;
  dates: string | undefined;
  price: string | undefined;
  paxes: string;
  departureTransport: PeekPriceMediumBookableTransportCardData;
  hotel: PeekPriceHotelCardData;
  arrivalTransport: PeekPriceMediumBookableTransportCardData;
}

export interface PeekPriceModalFerryPlusHotelItinerary {
  type: PeekPriceModalItineraryType.FerryPlusHotel;
  tripDeparture: string;
  dates: string | undefined;
  price: string | undefined;
  paxes: string;
  departureTransport: PeekPriceMediumBookableTransportCardData;
  hotel: PeekPriceHotelCardData;
  arrivalTransport: PeekPriceMediumBookableTransportCardData;
}

export interface PeekPriceModalUnavailableFerryPlusHotelItinerary {
  type: PeekPriceModalItineraryType.UnavailableFerryPlusHotel;
  paxes: string;
  dates: undefined;
  price: undefined;
}

export interface PeekPriceModalMultiIngredientItinerary {
  type: PeekPriceModalItineraryType.MultiIngredient;
  paxes: string;
  dates: string | undefined;
  price: string | undefined;
  inspectedAccommodationName: string;
  cards: PeekPriceMultiIngredientCard[];
}

export type PeekPriceModalItineraryData =
  | PeekPriceModalHotelOnlyItinerary
  | PeekPriceModalFlightPlusHotelItinerary
  | PeekPriceModalFerryPlusHotelItinerary
  | PeekPriceModalUnavailableFerryPlusHotelItinerary
  | PeekPriceModalMultiIngredientItinerary;
